import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetNotesFromApiRequest,
  GetNotesResponse,
  CreateNoteFromApiRequest,
  CreateNoteResponse,
  DeleteNoteFromAPIRequest,
  DeleteNoteResponse,
} from "../../models/Note.model";

const API_BASE_URL = environment.apiUrl;

export const getNotes = createAsyncThunk<
  GetNotesResponse,
  GetNotesFromApiRequest,
  { rejectValue: string }
>("note/getNotes", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Note/GetNotes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    
    // אם אין הערות (500), החזר מערך ריק
    if (response.status === 500) {
      return {
        success: true,
        message: "No notes found",
        notes: []
      };
    }
    
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetNotesResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to get notes");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const createOrUpdateNote = createAsyncThunk<
  CreateNoteResponse,
  CreateNoteFromApiRequest,
  { rejectValue: string }
>("note/createOrUpdateNote", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Note/CreateOrUpdeteNote`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: CreateNoteResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to create or update note");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const deleteNote = createAsyncThunk<
  DeleteNoteResponse,
  DeleteNoteFromAPIRequest,
  { rejectValue: string }
>("note/deleteNote", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Note/DeleteNote`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: DeleteNoteResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to delete note");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
